









































































































import "material-icons/iconfont/material-icons.css";
import Vue from "vue";
import AccessibleDialog from "@/components/AccessibleDialog.vue";

import {
  VMenu,
  VList,
  VCard,
  VListItem,
  VListItemTitle,
  VListItemIcon,
  VBtn,
  VIcon,
  VTooltip,
  VProgressCircular
} from "vuetify/lib";

export default Vue.extend({
  components: {
    VMenu,
    VList,
    VCard,
    VListItem,
    VListItemTitle,
    VListItemIcon,
    VBtn,
    VIcon,
    VTooltip,
    AccessibleDialog,
    VProgressCircular
  },
  data() {
    return {
      drawerIsShown: false,
      authIsLoading: true,
      resources: null as any,
      auth: null,
      overlayIsShown: false,
      overlayTimeout: {} as ReturnType<typeof setInterval>,
      window
    };
  },

  async created() {
    window.addEventListener(
      "message",
      async event => {
        if (event.data.url) {
          const iframe = document.getElementById("iframe");

          if (iframe) {
            const newTab = iframe.getAttribute("newTab") !== null;
            document.body.removeChild(iframe);
            this.$vtrs.createSSOIframe();
            this.$emit("ssoLoginCompleted", true);
            setTimeout(() => {
              this.overlayIsShown = false;
              clearTimeout(this.overlayTimeout);
              if (newTab) {
                window.open(event.data.url, "_blank");
              } else {
                window.location.href = event.data.url;
              }
            }, 200);
          }
        }
      },
      false
    );

    const success = await this.$vtrs.init();

    this.$set(this, "auth", this.$vtrs);

    this.$emit("auth", success);
  },
  methods: {
    openWebsite(url: string, override = false): void {
      if (this.$vtrs.config.baseSite === url) {
        if (override) {
          window.open(url, "_blank");
        } else {
          window.location.href = url;
        }
      } else {
        this.overlayIsShown = true;
        this.$vtrs.openWebsite(url, override);
      }

      this.overlayTimeout = setTimeout(() => {
        this.overlayIsShown = false;
      }, 30000);
    }
  },
  watch: {
    "auth.authenticated": {
      handler: function() {
        if (this.$vtrs.authenticated === true && this.auth !== null) {
          this.authIsLoading = false;

          if (this.$vtrs.resources) {
            this.resources = this.$vtrs.resources;
          }
        }
      },
      deep: true
    }
  }
});
